import { SpecimenResource } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { SpecimenDataStore } from "@skinsoft/entity";
import { SpecimenOfflineDataFetcher, CACHE_KEYS } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.location ?? config.syncDownPageSize.default

// @ts-ignore
export class SpecimenSyncDownHandler extends EntitySyncDownHandler<SpecimenResource, SpecimenResource, SpecimenResource> {
    private static instance: SpecimenSyncDownHandler = null as any

    public static getInstance() {
        if (!SpecimenSyncDownHandler.instance) {
            SpecimenSyncDownHandler.instance = new SpecimenSyncDownHandler()
        }

        return SpecimenSyncDownHandler.instance
    }

    public static install(Vue) {
        SpecimenSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.specimen],
            SpecimenDataStore.getInstance(),
            new SpecimenOfflineDataFetcher(),
            CACHE_KEYS.Specimen,
            SEARCH_PAGE_SIZE
        )
    }
}